import React from 'react';

const ProviderContext = React.createContext({});

export default ProviderContext;
